<template>
  <div class="onboarding-documents-container">
    <h1 class="title">Your Policy Documents</h1>
    <div class="onboarding-documents">
      <p>
        To activate your Porsche Auto Insurance coverage you must complete the
        items below:
      </p>

      <!--        TODO: [LIST REMAINING ITEMS ONLY, or still list the “done” items but put the word “Done!” to the right of the item, in green text.]-->
      <ul>
        <li v-show="hasEsignature">
          E-sign your policy application. Click
          <a :href="esignatureLink" target="_blank">here</a> to begin.
        </li>
        <li v-show="hasOdometer">
          <p>
            Submit an odometer photo for each vehicle on your policy. While
            viewing this page on your smartphone, click
            <a :href="odometerLink" target="_blank">here</a> to begin.
            <br />
            <span class="subtext">
              (if you reached this page via an email on a desktop or laptop
              computer, please open the email on your smartphone then click the
              link.)
            </span>
          </p>
        </li>
      </ul>

      <p>
        Once completed, we’ll send a confirmation email with access to your
        policy documents. If you need a copy of your Binder of Insurance, you
        can download a copy by clicking here.
      </p>

      <p>
        Thanks for choosing Porsche Auto Insurance – we’re glad you’re here!
      </p>

      <p>
        Need something else? Our Customer Concierge team is available to assist
        you Monday through Friday, 9AM to 5PM.
      </p>
      <p>
        You can reach us at
        <span style="white-space: nowrap;">
          <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a>
        </span>
        or email us at
        <span style="white-space: nowrap;">
          <a href="mailto:customercare@porscheautoinsurance.com">
            CustomerCare@PorscheAutoInsurance.com
          </a>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Onboarding',
  props: {
    documents: {
      type: Array,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    token: {
      type: String
    }
  },
  methods: {
    ...mapActions(['requestDocsLinks']),
    openDocument(item) {
      window.open(item.url, '_blank');
    }
  },
  computed: {
    esignatureLink() {
      return this.documents.filter(d => d.type === 'esignature');
    },
    hasEsignature() {
      return this.documents.filter(d => d.type === 'esignature').length > 0;
    },
    hasOdometer() {
      return this.documents.filter(d => d.type === 'odometer').length > 0;
    },
    odometerLink() {
      return this.documents.filter(d => d.type === 'odometer');
    }
  }
};
</script>

<style scoped>
.subtext {
  font-size: 0.85rem;
}
</style>
